import Item from './item.element.js';

export default Item;

Item.define('wje-item', Item);
